<template>
  <div>
    <span
      class="text-subtitle-1 grey--text text--darken-4"
    > {{ title }} </span>
    <span
      class="text-subtitle-1 grey--text text--darken-1"
      v-if="description"
    > - </span>
    <span
      v-if="description"
      class="text-subtitle-1 grey--text font-weight-bold text--darken-1"
    > {{ description }}</span>
  </div>
</template>

<script>
export default {
  name: 'titleDashDescription',
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>

</style>
